module.exports = __webpack_public_path__ + "static/media/tubes@2x.2fb70796.jpg";